module.exports = __webpack_public_path__ + "media/images/dont-know-31b904cfc5406e0c9fecf30465ba09ce.svg";